import React, { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

interface Html5ScannerProps {
    onScan: (text: string) => void;
    isScanning: boolean;
}

export const Html5Scanner: React.FC<Html5ScannerProps> = ({ onScan, isScanning }) => {
    const scannerRef = useRef<Html5Qrcode | null>(null);
    const containerId = "reader";

    useEffect(() => {
        if (!isScanning) return;

        const startScanner = async () => {
            // Give DOM some time to mount
            await new Promise(resolve => setTimeout(resolve, 300));

            try {
                if (!scannerRef.current) {
                    scannerRef.current = new Html5Qrcode(containerId);
                }

                if (!scannerRef.current.isScanning) {
                    await scannerRef.current.start(
                        { facingMode: "environment" },
                        {
                            fps: 10,
                            qrbox: { width: 250, height: 250 },
                        },
                        (decodedText: string) => {
                            onScan(decodedText);
                        },
                        () => { /* ignore */ }
                    );
                }
            } catch (err) {
                console.error("Scanner error:", err);
            }
        };

        startScanner();

        return () => {
            if (scannerRef.current && scannerRef.current.isScanning) {
                scannerRef.current.stop()
                    .catch(err => console.error("Error stopping scanner", err));
            }
        };
    }, [isScanning, onScan]);

    return (
        <div id={containerId} className="w-full h-full bg-black"></div>
    );
};
